import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyCVNuoOJJgOdncyyruQ86D9kRyMhnpjonk",
  authDomain: "dbos-core-prod.firebaseapp.com",
  projectId: "dbos-core-prod",
  storageBucket: "dbos-core-prod.firebasestorage.app",
  messagingSenderId: "293570284015",
  appId: "1:293570284015:web:e55d6be936c17e38204e1a",
  measurementId: "G-VJ3VCDZNHV"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);